export const QA_NAME_TABLE_CONTEXT = 'table_header'

export const SORT_PARAMS_MAX_COUNT = 5
